export class ApiEndPointsUser {

  // Summary
  // Call api to get user list
  userList = 'api/ManageUser/GetUserList';

  // Summary
  // Call api to register user
  registerUser = 'api/ManageUser/RegisterUser';

  getOrgOffices='api/Orgnization/GetOrgOffices'

  // Summary
  // Call api to get user detail
  getUserDetail = 'api/ManageUser/GetUserDetail';
  getUserOffices = 'api/ManageUser/GetUserOffices';
  // Summary
  // Call api to register user
  updateUser = 'api/ManageUser/UpdateUser';

  // Summary
  // Call api to delete user
  deleteUser = 'api/ManageUser/DeleteUser';

  // Summary
  // Call api to check existing user
  checkExistingUser = 'api/ManageUser/CheckExistingUser';

  // Summary
  // Call api to resetPassword
  resetPassword = 'api/ManageUser/ResetPassword';

  // Summary
  // Call api to send mail
  forgotPasswordCheckUser = 'api/ManageUser/GetForgotPasswordLink';

  
  // Summary
  // Call api to update password
  updatePassword = 'api/ManageUser/ForgotPassword';

  getLoggedInUserDetailsManageUser = 'api/ManageUser/GetUserProfileDetail';

  updateUserProfile = 'api/ManageUser/UpdateUserProfile';
  GetLoginDetails="api/Orgnization/GetLoginDetails";
  GetUserDetail= "api/ManageUser/GetUserDetail";
  GetUserList = 'api/ManageUser/GetUserList';
  getOrgs="api/Orgnization/GetOrgs";
}
